module.exports = __webpack_public_path__ + "static/media/YM84_4.195c8b30.jpg";